<template>
	<div class="container-fluid">
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Aktív kiszámlázatlan rendelések
    		</div>
		</div>
	    <div class="row d-flex justify-content-center">
	    	<div
	    		class="col-12"
	    		v-for="(item,index) in list"
	    		:key="item.rendelesszam"
	    	>
	    		<listitem
	    			:item="item"
	    		/>
	    	</div>
	    </div>
	</div>
</template>
<script type="text/javascript">
import listitem from './order_list_item'
export default {
	name: 'order_without_invoice',
	components: {
		listitem
	},
	data(){
		return {
			list: []
		}
	},
	mounted(){
		this.$Progress.start()
		this.req.post(`/orders/without_invoice`)
			.then(res => {
				this.list = res.data.list
				this.list = this.list.filter(x => x.list = JSON.parse(x.list))
			  	this.$Progress.finish()
			})
			.catch(err => {
				console.log(err)
				this.$Progress.fail()
			})
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/order_list/order_list.vue